"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicQuoteViewStore = exports.QuoteViewStore = exports.PlanCardSelectArea = exports.QuoteHideMode = void 0;
var DIProvider_1 = require("DIProvider/DIProvider");
var inversify_1 = require("inversify");
var mobx_1 = require("mobx");
var QuoteLabelStore_1 = __importDefault(require("QuoteV2/Labels/QuoteLabelStore"));
var QuoteBlockStore_1 = __importDefault(require("./QuoteBlockStore"));
var QuoteHideMode;
(function (QuoteHideMode) {
    QuoteHideMode["Invisible"] = "invisible";
    QuoteHideMode["Fade"] = "fade";
})(QuoteHideMode || (exports.QuoteHideMode = QuoteHideMode = {}));
var PlanCardSelectArea;
(function (PlanCardSelectArea) {
    PlanCardSelectArea["ButtonOnly"] = "buttonOnly";
    PlanCardSelectArea["EntireCard"] = "entireCard";
})(PlanCardSelectArea || (exports.PlanCardSelectArea = PlanCardSelectArea = {}));
var QuoteViewStore = (0, DIProvider_1.makeServiceIdentifier)(Symbol("QuoteViewStore"));
exports.QuoteViewStore = QuoteViewStore;
var PublicQuoteViewStore = (function () {
    function PublicQuoteViewStore(quote, labelStore, disableInteractives) {
        this.quote = quote;
        this.labelStore = labelStore;
        this.interactionDisabled = false;
        this.isSelectionEnabled = false;
        this.hideMode = QuoteHideMode.Invisible;
        this.planCardSelectArea = PlanCardSelectArea.EntireCard;
        this.showPlaceholders = false;
        this.interactionDisabled = disableInteractives;
    }
    Object.defineProperty(PublicQuoteViewStore.prototype, "selectedSectionId", {
        get: function () {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    PublicQuoteViewStore.prototype.setSelectedSection = function () { };
    PublicQuoteViewStore.prototype.getLabel = function (label) {
        var _this = this;
        return (0, mobx_1.computed)(function () { return _this.labelStore.getLabel(_this.quote.labelSetId, label); }).get();
    };
    Object.defineProperty(PublicQuoteViewStore.prototype, "isInteractive", {
        get: function () {
            return !this.interactionDisabled;
        },
        enumerable: false,
        configurable: true
    });
    PublicQuoteViewStore.prototype.disableInteraction = function () {
        this.interactionDisabled = true;
    };
    var _a, _b;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], PublicQuoteViewStore.prototype, "interactionDisabled", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], PublicQuoteViewStore.prototype, "isInteractive", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PublicQuoteViewStore.prototype, "disableInteraction", null);
    PublicQuoteViewStore = __decorate([
        (0, inversify_1.injectable)(),
        __param(2, (0, inversify_1.inject)("disableInteractives")),
        __metadata("design:paramtypes", [typeof (_a = typeof QuoteBlockStore_1.default !== "undefined" && QuoteBlockStore_1.default) === "function" ? _a : Object, typeof (_b = typeof QuoteLabelStore_1.default !== "undefined" && QuoteLabelStore_1.default) === "function" ? _b : Object, Boolean])
    ], PublicQuoteViewStore);
    return PublicQuoteViewStore;
}());
exports.PublicQuoteViewStore = PublicQuoteViewStore;
